var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivateNewNetworkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.062 4.977H8.251v15.099l15.811.217V5.977a1 1 0 0 0-1-1z",
    fill: "url(#ny7d0jenta)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 25.94c0-.353-.14-1.302-.39-1.552s-.59-.39-.943-.39H17.67V21.33h5.497a2.667 2.667 0 0 0 2.667-2.667V5.331a2.667 2.667 0 0 0-2.667-2.667H9.834a2.667 2.667 0 0 0-2.667 2.667v13.333a2.667 2.667 0 0 0 2.667 2.667h5.611v2.666h-1.611c-.354 0-.693.14-.943.39-.25.251-.39 1.2-.39 1.554H4.166a1 1 0 0 0-1 1v.056a1 1 0 0 0 1 1H12.5a1.333 1.333 0 0 0 1.334 1.334h5.333a1.333 1.333 0 0 0 1.333-1.334h8.334a1 1 0 0 0 1-1v-.056a1 1 0 0 0-1-1H20.5zM9.427 20.018a1 1 0 0 1-1-1V5.013a1 1 0 0 1 1-1H23.69a1 1 0 0 1 1 1v14.004a1 1 0 0 1-1 1H9.427zM20.5 12.331a1 1 0 0 1-1 1h-1.666v1.666a1 1 0 0 1-1 1h-.667a1 1 0 0 1-1-1v-1.666H13.5a1 1 0 0 1-1-1v-.667a1 1 0 0 1 1-1h1.667V8.997a1 1 0 0 1 1-1h.667a1 1 0 0 1 1 1v1.667H19.5a1 1 0 0 1 1 1v.667z",
    fill: "url(#arpeqflx0b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ny7d0jenta",
    x1: 8.251,
    y1: 13.757,
    x2: 23.796,
    y2: 8.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "arpeqflx0b",
    x1: 3.167,
    y1: 18.171,
    x2: 29.628,
    y2: 9.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateNewNetworkIcon);
export default __webpack_public_path__ + "static/media/activateNewNetworkIcon.468e1124db25b7575b14237740c74cb1.svg";
export { ForwardRef as ReactComponent };